export async function kullanicilariListele(istemci, sayfa = 1, boyut = 50) {
    return istemci.istek(`/kullanicilar?sayfa=${sayfa}&boyut=${boyut}`);
}
export async function kullaniciGetir(istemci, id) {
    return istemci.istek(`/kullanicilar/${id}`);
}
export async function rolleriListele(istemci) {
    return istemci.istek('/kullanicilar/rol-listesi');
}
export async function kullaniciOlustur(istemci, giris) {
    return istemci.istek('/kullanicilar', {
        method: 'POST',
        body: JSON.stringify(giris),
    });
}
export async function kullaniciGuncelle(istemci, id, giris) {
    return istemci.istek(`/kullanicilar/${id}`, {
        method: 'PUT',
        body: JSON.stringify(giris),
    });
}
export async function kullaniciSil(istemci, id) {
    await istemci.istek(`/kullanicilar/${id}`, { method: 'DELETE' });
}
//# sourceMappingURL=kullanicilar.js.map